import * as React from 'react';
import {fetchUtils, Form, maxLength, minLength, required, TextInput, useNotify, useRedirect,} from 'react-admin';
import {useFormContext} from 'react-hook-form';
import {useLocation} from 'react-router-dom';
import {ADMIN_AUTH_URL} from "../../constants/api-url";
import {errorsExtractor} from "../../utils/errors-extractor";
import {ErrorResponse, FetchError} from "../../types/errors-response";

const API_AUTH = ADMIN_AUTH_URL;

type ResetFormValues = {
  email: string;
  code: string;
  password: string;
  confirm: string;
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const SubmitButton = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const {setError,getValues, formState: {isValid, isLoading, isSubmitted}} = useFormContext<ResetFormValues>();

  const onSubmit = async () => {
    const { email, code, password, confirm } = getValues();

    if (password !== confirm) {
      setError('confirm', { type: 'validate', message: 'Passwords do not match' });
      return;
    }

    try {
      await fetchUtils.fetchJson(`${API_AUTH}/reset-password`, {
        method: 'POST',
        body: JSON.stringify({ email, code, password, confirm }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });

      notify('Password updated. You can now log in.', { type: 'info' });
      redirect('/login');
    } catch (e: unknown) {
      if(!e ||  typeof e !== 'object') {
        notify('Something went wrong.', { type: 'warning' });
        return
      }
      const {body} = e as FetchError<ErrorResponse>;

      if('details' in body) {
        errorsExtractor(body as ErrorResponse, setError)
        return;
      }
      notify(body.message || ('message' in e ? e.message as string : JSON.stringify(e)), { type: 'warning' });
    }
  };

  return (
    <div style={{ marginTop: 16 }}>
      <button type="button" disabled={(!isValid && isSubmitted) || isLoading} onClick={onSubmit} style={{ width: '100%', padding: 10 }}>
        Update password
      </button>
    </div>
  )
}

export default function ResetPassword() {
  const q = useQuery();

  const defaultValues: Partial<ResetFormValues> = {
    email: q.get('email') || '',
    code: q.get('code') || '',
    password: '',
    confirm: '',
  };

  return (
    <div style={{ maxWidth: 420, margin: '10vh auto' }}>
      <h2 style={{ marginBottom: 16 }}>Reset Password</h2>

      <Form
        defaultValues={defaultValues}
        noValidate
      >
        <TextInput
          source="email"
          type="email"
          label="Email"
          fullWidth
          validate={[required()]}
        />
        <TextInput
          source="code"
          label="Code from email"
          fullWidth
          validate={[required(), minLength(4), maxLength(4)]}
        />
        <TextInput
          source="password"
          type="password"
          label="New password"
          fullWidth
          validate={[required(), minLength(8)]}
        />
        <TextInput
          source="confirm"
          type="password"
          label="Confirm new password"
          fullWidth
          validate={[required(), minLength(8)]}
        />

        <SubmitButton/>
        <div style={{ marginTop: 12, textAlign: 'center' }}>
          <a href="/public#/login">Back to login</a>
        </div>
      </Form>
    </div>
  );
}
